import React, { useEffect } from "react";
import Header from "../components/header";
import bgImg from "../../assets/images/seller-auth.webp";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Toolbar } from "@mui/material";

const SellerAuth = ({ children }) => {
  const userInfo = useSelector((state) => state.user?.user?.profile);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const hasStore = userInfo?.hasPaidMembershipFee;

  useEffect(() => {
    if (!isAuthenticated) return;
    if (pathname === "/seller/select-plan") {
      return;
    }

    if (hasStore) {
      navigate("/seller/dashboard", { replace: true });
      return;
    }
 
  }, [hasStore, isAuthenticated, pathname, navigate]);

  return (
    <div className="min-h-[100dvh]">
      <Header />
      <Toolbar />
      <div className="flex lg:min-h-[100dvh] flex-col lg:flex-row">
        <div
          className="h-[200px] md:h-[100dvh] mt-5 md:mt-0 md:w-[40%] w-full box-border shrink-0 lg:block"
          style={{
            backgroundImage: `url(${bgImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          aria-hidden
        />
        <main className="box-border w-full overflow-y-auto  lg:w-[60%] lg:pt-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default SellerAuth;
